
import "../../../../components/css/info_components/info_content.css";
import "../../../../components/css/info_components/RevolvingBorder.css";

function WashingMachineContent() {
    return (
        <main>
            <center>
                <div className="info_parent">
                  
                        <div className="info_div2 info_info_background">
                            <div className="info_sub_part_div1">
                                <font className='font_menu_title_name'>
                                    Monday to Saturday
                                </font>
                            </div>
                            <div className="info_sub_part_div2">
                            </div>
                            <div className="menu_sub_part_div3">
                                <font className='font_info_description'>
                                    <div className="food_one_by_one">
                                        <div>Time 1 &nbsp;&#9679;&nbsp; 9:00 to 13:00</div>
                                        <div>Time 2 &nbsp;&#9679;&nbsp; 15:00 to 18:00</div>
                                    </div>
                                </font>
                            </div>
                        </div>
                  
                        <div className="info_div2 info_info_background">
                            <div className="info_sub_part_div1">
                                <font className='font_menu_title_name'>
                                    Only Sunday
                                </font>
                            </div>
                            <div className="info_sub_part_div2">
                            </div>
                            <div className="menu_sub_part_div3">
                                <font className='font_info_description'>
                                    <div className="food_one_by_one">
                                        <div>Time 1 &nbsp;&#9679;&nbsp; 9:00 to 13:00</div>
                                        <div>Time 2 &nbsp;&#9679;&nbsp; 15:00 to 19:00</div>
                                    </div>
                                </font>
                            </div>
                        </div>
                </div>
            </center>
        </main>
    );
}

export default WashingMachineContent;
